// Risolve i codici stabili restituiti dal backend (category_code, need code,
// categoria/area/uso/indicazioni prodotto, conflict axis) in etichette
// localizzate, leggendo da frontend/src/i18n/{it,en}/{categories,needs}.json.
// Sostituisce i dizionari hardcoded italiani che vivevano prima in
// AnalysisDetail.jsx (qualIndexRisk/qualWellness/... , BREAKDOWN_LABELS,
// OCCLUSION_SEVERITY, DANDRUFF_SEVERITY) — quei dizionari duplicavano a mano
// le soglie del motore TricoProtocol; ora il motore restituisce già il
// category_code, qui si traduce soltanto la stringa.
import { useTranslation } from "react-i18next";

export function useTricoVocab() {
  const { t } = useTranslation(["categories", "needs"]);

  return {
    // field: namespace dentro categories.json (es. "global_health", "sebum", "vlm", "index_name", "conflict_axis")
    categoryLabel: (field, code) => (code ? t(`categories:${field}.${code}`, { defaultValue: code }) : ""),
    indexName: (indexKey) => t(`categories:index_name.${indexKey}`, { defaultValue: indexKey }),
    conflictAxisLabel: (axisCode) => t(`categories:conflict_axis.${axisCode}`, { defaultValue: axisCode }),
    needCondizione: (code) => t(`needs:need.${code}.condizione`, { defaultValue: code }),
    needObiettivo: (code) => t(`needs:need.${code}.obiettivo`, { defaultValue: code }),
    categoriaProdotto: (code) => t(`needs:categoria.${code}`, { defaultValue: code }),
    areaProdotto: (code) => t(`needs:area.${code}`, { defaultValue: code }),
    usoProdotto: (code) => t(`needs:uso.${code}`, { defaultValue: code }),
    indicazioneProdotto: (code) => t(`needs:indicazione.${code}`, { defaultValue: code }),
  };
}
